export enum ActivityTableColumnDataIndex {
  Date = "date",
  Activity = "activity",
  Channels = "channels",
  FirstName = "firstName",
  LastName = "lastName",
  Program = "program",
  Action = "action",
}
